import { type RootState } from "features/Application/globaltypes/redux";
import { AddOnIds } from "enums";

export const getPurchasePacksAddonEnabled = (state: RootState): boolean => {
  const addons = state.accounts.addOns.items;
  return addons?.find((addon) => addon.id === AddOnIds.PurchasePacks)?.isEnabled || false;
};
